import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutstreamSingleAd = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 43,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 4,
			width: 44,
			height: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 9,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 13,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 17,
			width: 30,
			height: 22,
			rx: 1,
			fill: "var(--format-icon-color, #A8F0F0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7768 25.3646V30.6354C19.7768 30.9104 19.8952 31.1166 20.132 31.2541C20.3688 31.3916 20.6018 31.384 20.8309 31.2312L24.9788 28.5729C25.1927 28.4354 25.2997 28.2444 25.2997 28C25.2997 27.7555 25.1927 27.5646 24.9788 27.4271L20.8309 24.7687C20.6018 24.616 20.3688 24.6083 20.132 24.7458C19.8952 24.8833 19.7768 25.0896 19.7768 25.3646ZM21.9997 37.1666C20.7469 37.1666 19.5629 36.926 18.4476 36.4448C17.3323 35.9635 16.3584 35.3066 15.5257 34.4739C14.6931 33.6413 14.0361 32.6673 13.5549 31.5521C13.0736 30.4368 12.833 29.2528 12.833 28C12.833 26.7472 13.0736 25.5632 13.5549 24.4479C14.0361 23.3326 14.6931 22.3587 15.5257 21.526C16.3584 20.6934 17.3323 20.0364 18.4476 19.5552C19.5629 19.0739 20.7469 18.8333 21.9997 18.8333C23.2525 18.8333 24.4365 19.0739 25.5518 19.5552C26.667 20.0364 27.641 20.6934 28.4736 21.526C29.3063 22.3587 29.9632 23.3326 30.4445 24.4479C30.9257 25.5632 31.1663 26.7472 31.1663 28C31.1663 29.2528 30.9257 30.4368 30.4445 31.5521C29.9632 32.6673 29.3063 33.6413 28.4736 34.4739C27.641 35.3066 26.667 35.9635 25.5518 36.4448C24.4365 36.926 23.2525 37.1666 21.9997 37.1666ZM21.9997 35.7916C24.1386 35.7916 25.9719 35.0278 27.4997 33.5C29.0275 31.9722 29.7913 30.1389 29.7913 28C29.7913 25.8611 29.0275 24.0278 27.4997 22.5C25.9719 20.9722 24.1386 20.2083 21.9997 20.2083C19.8608 20.2083 18.0275 20.9722 16.4997 22.5C14.9719 24.0278 14.208 25.8611 14.208 28C14.208 30.1389 14.9719 31.9722 16.4997 33.5C18.0275 35.0278 19.8608 35.7916 21.9997 35.7916Z",
			fill: "white"
		})
	]
});
export default SvgOutstreamSingleAd;
